import * as React from 'react';
import { useSelector } from 'react-redux';
import { ArticleParagraph1 } from '@cian/ui-kit';
import { getDeveloperRegions } from '../../selectors';
import { IRegion } from '../../types/regions';

export function WorkRegions() {
  const regions = useSelector(getDeveloperRegions);
  const regionsToString = prepareRegionsToString(regions);

  return (
    <ArticleParagraph1>
      <b>Регионы работы:</b> {regionsToString}
    </ArticleParagraph1>
  );
}

function prepareRegionsToString(regions: IRegion[]) {
  return regions.map(region => region.name).join(', ');
}
